import { isApiError } from "../../api";
import styles from "../../styles/error-fallback.module.css";

function getErrorMessage(error: Error): string {
  if (!isApiError(error)) {
    return "发生了意外错误";
  }
  if (error.status === 0) return "网络连接异常，请检查网络后重试";
  if (error.status === 403) return "您没有权限访问此内容";
  if (error.status === 404) return "请求的资源不存在";
  if (error.status >= 500) return "服务暂时不可用，请稍后重试";
  return "发生了意外错误";
}

export function ErrorFallback({ error }: { error: Error }) {
  const message = getErrorMessage(error);

  return (
    <div className={styles.container}>
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <p className={styles.message}>{message}</p>
      <button type="button" className={styles.retryBtn} onClick={() => window.location.reload()}>
        重试
      </button>
    </div>
  );
}
